import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Button from '@/components/Button'
import Card from '@/components/Card'
import CopyTextButton from '@/components/CopyTextButton'
import KeyValue from '@/components/KeyValue'

import messages from './messages'

import './index.scss'

const NewCustomConnectorView = ({ connector, okClick }: any) => (
  <Card className="new-connector-display">
    <Card.Content>
      <div className="read-only-label">
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.name} />
          </KeyValue.Label>
          <KeyValue.Value>{connector.name}</KeyValue.Value>
        </KeyValue>
      </div>
      {connector.webhookUrl && (
        <div className="read-only-label">
          <KeyValue>
            <KeyValue.Label>
              <FormattedMessage {...messages.webHookUrl} />
            </KeyValue.Label>
            <KeyValue.Value>{connector.webHookUrl}</KeyValue.Value>
          </KeyValue>
        </div>
      )}
      <div className="read-only-label">
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.iconUrl} />
          </KeyValue.Label>
          <KeyValue.Value>{connector.iconUrl}</KeyValue.Value>
        </KeyValue>
      </div>
      <div className="sensitive-wrapper">
        {connector.clientCredential.clientId && (
          <KeyValue>
            <KeyValue.Label>
              <FormattedMessage {...messages.clientId} />
            </KeyValue.Label>
            <KeyValue.Value>{connector.clientCredential.clientId}</KeyValue.Value>
          </KeyValue>
        )}
        {connector.clientCredential.clientSecret && (
          <KeyValue>
            <KeyValue.Label>
              <FormattedMessage {...messages.clientSecret} />{' '}
              <span className="warning">
                <FormattedMessage {...messages.onlyDisplayedOnce} />
              </span>
            </KeyValue.Label>
            <KeyValue.Value>{connector.clientCredential.clientSecret} </KeyValue.Value>
            <CopyTextButton text={connector.clientCredential.clientSecret} />
          </KeyValue>
        )}
      </div>
    </Card.Content>
    <Card.Footer>
      <Button color="primary" onClick={okClick}>
        <FormattedMessage {...messages.ok} />
      </Button>
    </Card.Footer>
  </Card>
)

NewCustomConnectorView.displayName = 'NewCustomConnectorView'

NewCustomConnectorView.propTypes = {
  connector: PropTypes.shape({
    clientCredential: PropTypes.shape({
      clientSecret: PropTypes.string
    }),
    iconUrl: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    webHookUrl: PropTypes.string
  }).isRequired,
  okClick: PropTypes.func.isRequired
}

export default NewCustomConnectorView
